// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import styled from "styled-components/macro"
import SvgIcon from "features/shared/SvgIcon"

const Button = styled.button`
  cursor: pointer;
  padding: 7px 10px 8px;
  border-radius: 2px;
  margin-left: -10px;
  align-self: center;
  color: ${({ theme }): string => theme.colors.dimGray};
  transition: background-color 100ms ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.wildSand};
  }
`

const StyledIcon = styled(SvgIcon)`
  width: 8px;
  min-width: 8px;
  height: 8px;
  vertical-align: 0;
`

type Props = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
}

const ActionTimeRowRemoveButton = ({ onClick }: Props): React.ReactElement<Props> => {
  return (
    <Button onClick={onClick}>
      <StyledIcon name="close"/>
    </Button>
  )
}

export default ActionTimeRowRemoveButton
